import { Carousel, Skeleton } from "antd";
import "./styled/slider.css";
import { useEffect, useState } from "react";
const SampleNextArrow = (props) => {
	const { onClick } = props;
	return (
		<div className="arrowslide rightSlide" onClick={onClick}>
			<i className="icon-chevron"></i>
		</div>
	);
};
const SamplePrevArrow = (props) => {
	const { onClick } = props;
	return (
		<div className="arrowslide prevSlide" onClick={onClick}>
			<i className="icon-chevron"></i>
		</div>
	);
};
const settings = {
	nextArrow: <SampleNextArrow />,
	prevArrow: <SamplePrevArrow />,
};
const SliderBannerLogin = () => {
	const [loading, setLoading] = useState(true);
	useEffect(() => {
		setTimeout(() => {
			setLoading(false);
		}, 1000);
	}, []);
	return (
		<>
			{loading ? (
				<Skeleton.Image style={{ minWidth: "600px", height: "509px" }} active="true" />
			) : (
				<Carousel arrows {...settings} style={{ overflow: "hidden", borderRadius: "0.75rem" }} className="banner-login" autoplay effect="scrollx">
					<div style={{ borderRadius: "0.75rem" }}>
						<a target="_blank" href="http://auction.aptel.ir">
							<img
								style={{ width: "100%", borderRadius: "0.75rem" }}
								src={process.env.PUBLIC_URL + process.env.REACT_APP_PATH + "/assets/images/banners/auction.jpg"}
								alt=""
							/>
						</a>
					</div>
					<div style={{ borderRadius: "0.75rem" }}>
						<a target="_blank" href="https://www.aptel.ir/s/app">
							<img
								style={{ width: "100%", borderRadius: "0.75rem" }}
								src={process.env.PUBLIC_URL + process.env.REACT_APP_PATH + "/assets/images/banners/mobile-app.jpg?v=0.1"}
								alt=""
							/>
						</a>
					</div>
					<div style={{ borderRadius: "0.75rem" }}>
						<a target="_blank">
							<img
								style={{ width: "100%", borderRadius: "0.75rem" }}
								src={process.env.PUBLIC_URL + process.env.REACT_APP_PATH + "/assets/images/banners/free-call.jpg?v=0.1"}
								alt=""
							/>
						</a>
					</div>

					{/* <div style={{ borderRadius: "0.75rem" }}>
						<a target="_blank">
							<img
								style={{ width: "100%", borderRadius: "0.75rem" }}
								src={process.env.PUBLIC_URL + process.env.REACT_APP_PATH + "/assets/images/banners/Number-9-Banner-Tablet-Seller.jpg"}
								alt=""
							/>
						</a>
					</div> */}

					{/* <div style={{ borderRadius: "0.75rem" }}>
						<a target="_blank" href="https://simcardstore.aptel.ir/modem/html/modem.html">
							<img
								style={{ width: "100%", borderRadius: "0.75rem" }}
								src={process.env.PUBLIC_URL + process.env.REACT_APP_PATH + "/assets/images/banners/modem-purchase.jpg"}
								alt=""
							/>
						</a>
					</div> */}

					{/* <div style={{ borderRadius: "0.75rem" }}>
						<img
							style={{ width: "100%", borderRadius: "0.75rem" }}
							src={process.env.PUBLIC_URL + process.env.REACT_APP_PATH + "/assets/images/banners/Emirat-Roming-Sellerr.jpg"}
							alt=""
						/>
					</div> */}
					<div style={{ borderRadius: "0.75rem" }}>
						<img
							style={{ width: "100%", borderRadius: "0.75rem" }}
							src={process.env.PUBLIC_URL + process.env.REACT_APP_PATH + "/assets/images/banners/03.jpg"}
							alt=""
						/>
					</div>
				</Carousel>
			)}
		</>
	);
};

export default SliderBannerLogin;
